import { render, staticRenderFns } from "./button-create.vue?vue&type=template&id=5fb57d38"
import script from "./button-create.vue?vue&type=script&lang=js"
export * from "./button-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports